import { Component, OnInit } from '@angular/core';
import { ViewController, AlertController, NavParams } from 'ionic-angular';
import { GenFormBuilder } from '../../../../providers/form';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ENV } from '@app/env';

export interface IQuestionOption {
  text: { es: string; en: string; };
  value: string;
  points: number;
}

@Component({
  selector: 'app-form-question',
  templateUrl: 'form-question.component.html'
})

export class FormQuestionComponent implements OnInit {

  public inputTypes: string[];
  public language: string;
  public language_menu: "en" | "es" = "es";
  public questionForm: FormGroup;
  public submitAttempt = false;
  public types: string[];

  constructor(
    public viewCtrl: ViewController,
    public genForm: GenFormBuilder,
    public formBuilder: FormBuilder,
    public alertCtrl: AlertController,
    public navParams: NavParams
  ) { }

  ngOnInit() {
    this.initTypes();
    this.initForm();
    this.initTypeListener();
  }

  public initForm() {
    this.questionForm = this.formBuilder.group({
      type: [null, Validators.required],
      order: [null, Validators.required],
      step: [null, Validators.required],
      data: {}
    });
    if (this.question) this.questionForm = this.question;
    return this.questionForm;
  }

  public initTypeListener() {
    this.questionForm.get('type')
      .valueChanges
      .subscribe(value => this.addDataControl(value, this.questionForm));
  }

  public addDataControl(type: string, group: FormGroup) {
    switch (type) {
      case 'input':
      case 'textarea':
        group.setControl('data', this.inputGroup(type));
        return;
      case 'checkbox':
      case 'radio':
      case 'select':
        group.setControl('data', this.listGroup(type));
        return;
      default:
        console.log('Invalid question type: ', type);
        return;
    }
  }

  public get question(): FormGroup {
    return this.navParams.get('question');
  }

  public get options(): IQuestionOption[] {
    return this.navParams.get('options');
  }

  public inputGroup(type: string): FormGroup {
    const group = this.formBuilder.group({});
    this.genForm.genInputString('name', group, true);
    this.genForm.genToggle('required', group, true);
    this.genForm.genInputLang('label', group);
    this.genForm.genInputLang('placeholder', group);
    this.genForm.genInputNumber('points', group, false);
    if (type === 'input') {
      this.genForm.genInputString('inputType', group, true);
    }
    if (type === 'textarea') {
      this.genForm.genInputNumber('min', group, false);
      this.genForm.genInputNumber('max', group, false);
    }
    return group;
  }

  public listGroup(type: string): FormGroup {
    const group = this.formBuilder.group({});
    this.genForm.genInputString('name', group, true);
    this.genForm.genToggle('required', group, true);
    this.genForm.genInputLang('label', group);
    group.addControl('options', this.defaultOptions);
    if (type === 'select') this.genForm.genToggle('multiple', group, true);
    return group;
  }

  public createOptionGroup(option: IQuestionOption) {
    const optionGroup = this.formBuilder.group({
      value: [option.value, Validators.required],
      points: [option.points, Validators.required],
    });
    this.genForm.genInputLang('text', optionGroup, this.language, option.text);
    return optionGroup;
  }

  public get defaultOptions(): FormArray {
    if (this.options) {
      const options = this.options.map(o => this.createOptionGroup(o));
      return this.formBuilder.array(options);
    } else {
      return this.formBuilder.array([]);
    }
  }


  public initTypes() {
    this.inputTypes = ['text', 'number', 'tel', 'email', 'password'];
    this.types = ['input', 'checkbox', 'textarea', 'radio', 'select'];
  }

  onItemSelected(item: string) {
    this.viewCtrl.dismiss(item);
  }

  addOption() {
    this.alertCtrl.create({
      title: 'New option',
      message: 'Enter name and value fields for new option',
      inputs: [
        { type: 'input', name: 'text_es', label: 'Text es', placeholder: 'Text ES' },
        { type: 'input', name: 'text_en', label: 'Text en', placeholder: 'Text EN' },
        { type: 'input', name: 'value', label: 'Value', placeholder: 'Value' },
        { type: 'number', name: 'points', label: 'Points', placeholder: 'Points' },
      ],
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Add', role: 'cancel', handler: data => {
            if (data) {
              if ((data.text_es || data.text_en) && data.value) {
                const text = { es: data.text_es, en: data.text_en };
                const option: IQuestionOption = {
                  text,
                  value: data.value,
                  points: data.points
                };
                this.pushOptionGroup(option);
              }
            }
          }
        }
      ]
    }).present();
  }

  pushOptionGroup(option: IQuestionOption) {
    const optionGroup = this.createOptionGroup(option);
    const options = this.questionForm.get('data').get('options') as FormArray;
    options.push(optionGroup);
  }

  deleteOption(i: number) {
    const options = this.questionForm.get('data').get('options') as FormArray;
    options.removeAt(i);
  }

  saveQuestion({ valid }: { valid: boolean }) {
    this.submitAttempt = true;
    if (valid) {
      this.viewCtrl.dismiss(this.questionForm);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/form-users/components/form-question/form-question.component.ts